/**
 * Lazy loader for the Action Links runner chunk (actions.js) — the
 * forms-loader pattern: the import URL is computed at runtime from the
 * widget script's own directory so esbuild leaves the `import()` native.
 */
import type { createActionRunner } from './action-runner';

export type ActionsModule = { createActionRunner: typeof createActionRunner };

let chunkBase: string | null = null;
let cached: Promise<ActionsModule> | null = null;

/** Set once at boot from the app.js directory (same base as daily/tours/forms). */
export function setActionsChunkBase(base: string): void {
  chunkBase = base.replace(/\/$/, '');
}

export function loadActions(): Promise<ActionsModule> {
  if (!cached) {
    if (!chunkBase) {
      return Promise.reject(new Error('[showpilot] actions chunk base not configured'));
    }
    const url = `${chunkBase}/actions.js`;
    cached = import(/* @vite-ignore */ url)
      .then((m: Partial<ActionsModule>) => {
        if (typeof m.createActionRunner !== 'function') {
          throw new Error('[showpilot] actions chunk loaded but module shape is wrong');
        }
        return m as ActionsModule;
      })
      .catch((err: unknown) => {
        cached = null;
        throw err;
      });
  }
  return cached;
}

export function resetActionsLoaderForTests(): void {
  chunkBase = null;
  cached = null;
}
